/**
 * Created by rhinov15 on 28/01/2016.
 *
 */
/**
 * This is the state used n designer view when the map is locked and cannot be modified
 */
import { ActionState, ActionStateEnum } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { Entity, Events, eventsManager, Listener, math } from "@rhinov/savane-js";



export class IdleVisualiseState extends ActionState {

    // We do not display the background user map picture, it is useless here
    userMapShow: boolean = false;
    // Current state enum value
    state: number = ActionStateEnum.idleVisualise;
    _previousGridState: boolean;
    planFloorChanged: Listener | null;

    constructor(init?: boolean) {
        super();
        // Send an event telling not to display wall dots of the map
        eventsManager.instance.dispatch(Events.TOGGLE_WALL_DOTS, false);
       

        // Save grid state (displayed or not) before entering into this state to restore it at the end (we will hide it here)
        if (init == undefined) {
            // Retrieve grid display state from PlanManager
            this._previousGridState = PlanManager.getInstance().scrollWindow.grid._isGridVisible;
            // Inform PlanManager not to display the grid now
            PlanManager.getInstance().scrollWindow.grid._isGridVisible = false;
            // If any wall displayed for the current floor
            if (PlanManager.getInstance().world.currentScene!.currentFloor!.walls.length > 0) {
                // Send an event to hide the grid
                eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, false);
            }
        }
        else {
            this._previousGridState = false;
        }

        // Listen to any plan floor change
        this.planFloorChanged = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.lockView.bind(this));
    }

    // Return state enum value
    getAction(): number {
        return this.state;
    }

    // Parse all rooms and mark then as in visualisation mode (they'll be displayed with a solid fill color)
    lockView() {
        // Get room list from PlanManager
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;

        // Parse them all to get each node and inform them to be in visualisation mode
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }

    lockViewNoOffset() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true, false);
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, false);
        // Get room list from PlanManager
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;

        // Parse them all to get each node and inform them to be in visualisation mode
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }

    // Mouse click down, inform plan manager that the grid might be dragged from now (start dragging)
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton?: number): ActionState | null {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;

        PlanManager.getInstance().scrollWindow._startDragging(posx, posy, true);

        return null;
    }

    // Mouse moved, inform plan manager that the grid might be moved if there was a click down previously
    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition);
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;

        PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);

        return null;
    }

    // Mouse click up, let's check if anything underneath the mouse cursor
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        // Hide any tulip potentially already opened
        eventsManager.instance.dispatch(Events.HIDE_TULIP);

        // If any selected entity
        if (hoverEntities && hoverEntities.length > 0) {
            var entity = hoverEntities[0];
            /*          if(entity.entityType === SceneConstants.EntityType.UserPicture)
                        {
                            PlanManager.getInstance().updateItemsSelected([entity], false, false);
                            eventsManager.instance.dispatch(Events.CAMERA_ZOOM_PHOTO, entity);
                        }
                        else
                        {*/
            // Set the entity to selected state and open it's tulip
            PlanManager.getInstance().updateItemsSelected([entity], false, mouseButton === 2);
            //          }
        }
        else {
            PlanManager.getInstance().updateItemsSelected(null, false, false);
        }

        // End dragging point of grid
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;

        // Inform plan manager the grid is no longer dragged
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);

        return null;
    }

    actionEditEnded() {
        // Nothing to do here, there is no edition in this state
    }

    isDecorationState(): boolean {
        return (true);
    }

    // End of this visualisation state
    dispose() {
        // Put back dots for the wall corners
        eventsManager.instance.dispatch(Events.TOGGLE_WALL_DOTS, true);
        // Restore grid state as what it was previously
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, this._previousGridState);
        PlanManager.getInstance().scrollWindow.grid.unlockGrid();
        // Inform all rooms they aren't in visualisation state anymore (parse them all and mark them)
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;

        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);

            if (roomNode !== null) {
                roomNode.endVisualiseMode();
            }
        }
        // Remove plan floor changed listener
        eventsManager.instance.removeListener(this.planFloorChanged!);
    }
}

